export default "__VITE_ASSET__Bm$Ms4PY__"